import { render, staticRenderFns } from "./ComplaintDetailType.vue?vue&type=template&id=3538ffb4&scoped=true"
import script from "./ComplaintDetailType.vue?vue&type=script&lang=js"
export * from "./ComplaintDetailType.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDetailType.vue?vue&type=style&index=0&id=3538ffb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3538ffb4",
  null
  
)

export default component.exports